var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 8.66667C8.10461 8.66667 9.00004 7.77124 9.00004 6.66667C9.00004 5.5621 8.10461 4.66667 7.00004 4.66667C5.89547 4.66667 5.00004 5.5621 5.00004 6.66667C5.00004 7.77124 5.89547 8.66667 7.00004 8.66667Z",
    fill: "#686F74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 1.33333H10.22L9.39337 0.433333C9.14671 0.16 8.78671 0 8.41337 0H5.58671C5.21337 0 4.85337 0.16 4.60004 0.433333L3.78004 1.33333H1.66671C0.933374 1.33333 0.333374 1.93333 0.333374 2.66667V10.6667C0.333374 11.4 0.933374 12 1.66671 12H12.3334C13.0667 12 13.6667 11.4 13.6667 10.6667V2.66667C13.6667 1.93333 13.0667 1.33333 12.3334 1.33333ZM7.00004 10C5.16004 10 3.66671 8.50667 3.66671 6.66667C3.66671 4.82667 5.16004 3.33333 7.00004 3.33333C8.84004 3.33333 10.3334 4.82667 10.3334 6.66667C10.3334 8.50667 8.84004 10 7.00004 10Z",
    fill: "#686F74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraicon);
export default __webpack_public_path__ + "static/media/camera.icon.ef374209dc8822255dc493964c352402.svg";
export { ForwardRef as ReactComponent };